'use client'
import { useEffect, useState } from 'react'
import { Spinner, Center } from '@chakra-ui/react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FeedListItem } from '@/types/feed'
import { Card } from '../components/Card'
import { EmptyResult } from '../components/EmptyResult'
import { fetchFeedsAction } from '../actions'

type FeedListProps = {
  keyword?: string
  initialItems: FeedListItem[]
  totalItemCount?: number
}

export const FeedList = ({ keyword, initialItems, totalItemCount }: FeedListProps) => {
  const [extraLoadedItems, setExtraLoadedItems] = useState<FeedListItem[]>([])
  const [page, setPage] = useState(1)
  const feeds = initialItems.concat(extraLoadedItems)

  useEffect(() => {
    setPage(1)
    setExtraLoadedItems([])
  }, [keyword])

  useEffect(() => {
    if (page === 1) return
    const loadMore = async () => {
      const res = await fetchFeedsAction({ keyword, page })
      if (res.ok) {
        const loadedItems = res.payload
        setExtraLoadedItems(extraLoadedItems.concat(loadedItems))
      }
    }
    loadMore()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  return (
    <InfiniteScroll
      dataLength={feeds.length}
      next={() => {
        setPage(page + 1)
      }}
      hasMore={typeof totalItemCount === 'undefined' ? true : feeds.length !== totalItemCount}
      loader={
        <Center height="200px">
          <Spinner />
        </Center>
      }
    >
      {feeds.length === 0 && <EmptyResult />}
      {feeds.map((feed, index) => (
        <Card feed={feed} isLinkable={true} shouldShowFull={false} key={index} />
      ))}
    </InfiniteScroll>
  )
}
